module.exports = __webpack_public_path__ + "img/30_56.81faae8f.png";